// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css */
:root {
  --dark-blue: #1a237e;
  --light-blue: #3949ab;
  --white: #ffffff;
  --font-family: 'Arial, sans-serif';
}

body {
  background-color: var(--white);
  color: var(--dark-blue);
  font-family: var(--font-family);
}

.navbar {
  background-color: var(--white) !important;
  height: 75px;
}


.sidebar {
  background-color: var(--light-blue);
  min-height: calc(87vh - 54px);
  padding-top: 20px;
}

.sidebar-nav .nav-link {
  color: var(--white);
  font-family: var(--font-family);
  font-size: 18px; 
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-radius: 5px;
}

.sidebar-nav .nav-link:hover,
.sidebar-nav .nav-link:focus {
  background-color: var(--dark-blue);
}

.nav-icon {
  margin-right: 10px;
  font-size: 20px; 
}

.main-content {
  padding: 20px;
}

.modal-content {
  border-color: var(--light-blue);
}

.modal-header {
  background-color: var(--light-blue);
  color: var(--white);
}

.modal-title {
  color: var(--white);
}

.modal-footer .btn-primary {
  background-color: var(--dark-blue);
  border-color: var(--dark-blue);
}

.modal-footer .btn-primary:hover,
.modal-footer .btn-primary:focus {
  background-color: var(--light-blue);
  border-color: var(--light-blue);
}
@media (max-width: 768px) {
  .sidebar {
    min-height: auto;
    margin-bottom: 20px;
  }
}

.card {
  border-color: var(--light-blue);
}

.card-title {
  color: var(--dark-blue);
}

.btn-primary {
  background-color: var(--dark-blue);
  border-color: var(--dark-blue);
}

.btn-primary:hover,
.btn-primary:focus {
  background-color: var(--light-blue);
  border-color: var(--light-blue);
}

.table-container {
  width: 100%;
  height: 500px; /* Adjust as needed */
  overflow-y: auto;
  border: 1px solid #ddd;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 8px 16px;
  border: 1px solid #ddd;
}

thead th {
  position: sticky;
  top: 0;
  background-color: #f2f2f2; /* Adjust as needed */
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;;AAGA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;;EAEE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;;EAEE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa,EAAE,qBAAqB;EACpC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB,EAAE,qBAAqB;EAChD,UAAU;AACZ","sourcesContent":["/* src/App.css */\n:root {\n  --dark-blue: #1a237e;\n  --light-blue: #3949ab;\n  --white: #ffffff;\n  --font-family: 'Arial, sans-serif';\n}\n\nbody {\n  background-color: var(--white);\n  color: var(--dark-blue);\n  font-family: var(--font-family);\n}\n\n.navbar {\n  background-color: var(--white) !important;\n  height: 75px;\n}\n\n\n.sidebar {\n  background-color: var(--light-blue);\n  min-height: calc(87vh - 54px);\n  padding-top: 20px;\n}\n\n.sidebar-nav .nav-link {\n  color: var(--white);\n  font-family: var(--font-family);\n  font-size: 18px; \n  display: flex;\n  align-items: center;\n  padding: 10px 15px;\n  border-radius: 5px;\n}\n\n.sidebar-nav .nav-link:hover,\n.sidebar-nav .nav-link:focus {\n  background-color: var(--dark-blue);\n}\n\n.nav-icon {\n  margin-right: 10px;\n  font-size: 20px; \n}\n\n.main-content {\n  padding: 20px;\n}\n\n.modal-content {\n  border-color: var(--light-blue);\n}\n\n.modal-header {\n  background-color: var(--light-blue);\n  color: var(--white);\n}\n\n.modal-title {\n  color: var(--white);\n}\n\n.modal-footer .btn-primary {\n  background-color: var(--dark-blue);\n  border-color: var(--dark-blue);\n}\n\n.modal-footer .btn-primary:hover,\n.modal-footer .btn-primary:focus {\n  background-color: var(--light-blue);\n  border-color: var(--light-blue);\n}\n@media (max-width: 768px) {\n  .sidebar {\n    min-height: auto;\n    margin-bottom: 20px;\n  }\n}\n\n.card {\n  border-color: var(--light-blue);\n}\n\n.card-title {\n  color: var(--dark-blue);\n}\n\n.btn-primary {\n  background-color: var(--dark-blue);\n  border-color: var(--dark-blue);\n}\n\n.btn-primary:hover,\n.btn-primary:focus {\n  background-color: var(--light-blue);\n  border-color: var(--light-blue);\n}\n\n.table-container {\n  width: 100%;\n  height: 500px; /* Adjust as needed */\n  overflow-y: auto;\n  border: 1px solid #ddd;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth, td {\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n}\n\nthead th {\n  position: sticky;\n  top: 0;\n  background-color: #f2f2f2; /* Adjust as needed */\n  z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
